import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { useFocusEffect } from "@react-navigation/native";
import { useDebouncedCallback } from "use-debounce";
import {
  WidgetEmployeeLeavePreviewQuery,
  WidgetEmployeeLeavePreviewQuery$variables,
} from "./__generated__/WidgetEmployeeLeavePreviewQuery.graphql";
import { WIDGET_EMPLOYEE_LEAVE_PREVIEW_QUERY } from "./WidgetEmployeeLeavePreview";

export function useWidgetEmployeeLeaveSchedulePreviewQueryLoader({
  storecastId,
  teamIds,
  leaveReasonIds,
}: {
  storecastId: string;
  teamIds: string[];
  leaveReasonIds: string[];
}) {
  const [query, loadQuery] = useQueryLoader<WidgetEmployeeLeavePreviewQuery>(
    WIDGET_EMPLOYEE_LEAVE_PREVIEW_QUERY
  );

  const environment = useRelayEnvironment();
  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[], newLeaveReasonIds: string[]) => {
      try {
        const variables: WidgetEmployeeLeavePreviewQuery$variables = {
          storecastId,
          input: {
            size: "TWO_X_FOUR",
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            whitelistLeaveReasonIds:
              newLeaveReasonIds.length === 0 ? null : newLeaveReasonIds,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_EMPLOYEE_LEAVE_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables);
      } catch {}
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds, leaveReasonIds);
    }, [teamIds, loadPreviewQuery, leaveReasonIds])
  );
  return query;
}
